<template>
  <header class="page-finishings-header">
    <!-- Title -->
    <div class="row-1">
      <h1
        data-animate="header-title"
        class="title-m page-finishings-header__title"
        v-if="header?.generalHeaderTitle"
      >
        {{ header.generalHeaderTitle }}
      </h1>
      <div
        v-if="header?.generalHeaderText"
        data-animate="header-content"
        class="page-finishings-header__text text-l m-top-6"
        v-html="header.generalHeaderText"
      />
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesFinishingsHeader',
}
</script>

<script setup>
const props = defineProps({
  header: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
